export enum CustomerTypeEnum {
  Producer = 'Milk Producer',
  Plant = 'Plant',
}
